import { withStyles, Box } from 'vopay';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Title, UtilButton } from 'UI';
import ElinxSettingsForm from './ElinxSettingsForm';
import styles from './ElinxSettingsPage.module.scss';

const cn = withStyles(styles);

const ElinxSettingsPage = () => {
  const history = useHistory();
  const { t } = useTranslation('translations', { keyPrefix: 'Settings' });

  return (
    <div className={cn('elinxSettingsPage')}>
      <UtilButton iconLeft="chevron_left" size="large" onClick={() => history.goBack()}>
        {t('ELinx.back', { defaultValue: 'Back' })}
      </UtilButton>
      <Box flx="col">
        <Title className={cn('title')}>{t('ELinx.title', { defaultValue: 'eLinx Settings' })}</Title>
        <ElinxSettingsForm onClose={() => history.goBack()} />
      </Box>
    </div>
  );
};

export default ElinxSettingsPage;
